module.exports = __webpack_public_path__ + "static/media/Vintage_main_p.9c293d34.jpg";